/**
 * 图片版本号统一管理
 * 在这里修改版本号，会影响所有使用图片的地方
 */

// 图片版本号配置
export const IMAGE_VERSION_CONFIG = {
    // 主版本号 - 用于CSS中的图片URL
    version: import.meta.env.VITE_IMAGE_VERSION,

    // 开发环境是否启用版本号
    enableInDev: false,

    // 获取完整的版本号参数
    getVersionParam(): string {
        return `v=${this.version}`;
    },

    // 获取版本号（不包含 v= 前缀）
    getVersion(): string {
        return this.version;
    },

    // 更新版本号
    updateVersion(newVersion: string): void {
        this.version = newVersion;
    },

    // 根据环境决定是否使用版本号
    shouldUseVersion(): boolean {
        const isDev = import.meta.env.DEV;
        return !isDev || this.enableInDev;
    },
};

export const getImageVersion = () => IMAGE_VERSION_CONFIG.getVersion();
export const getImageVersionParam = () => IMAGE_VERSION_CONFIG.getVersionParam();
export const shouldUseImageVersion = () => IMAGE_VERSION_CONFIG.shouldUseVersion();
